<template>
  <section class="wc-header__top border-bottom">
    <div class="d-flex justify-content-between px-3 container-xl font-size-sm">
      <WCEmployeeAssociationBanner v-if="isEmployee && isCustomer" />
      <div v-else-if="locationPhone && locationPhone.phone">
        <a :href="`tel:${locationPhone}`" class="d-block underline-link-from-center my-1">
          <font-awesome-icon class="mr-1" icon="phone" />
          {{ $t('callUs') }}: {{ locationPhone }}
        </a>
      </div>
      <nav :aria-label="$t('main')" role="navigation" class="ml-auto">
        <ul class="nav">
          <li class="nav-item" v-if="isEmployee && !isCustomer">
            <router-link class="nav-link" to="/employee">{{ $t('employeeDashboard') }}</router-link>
          </li>
          <li class="nav-item" data-testid="header-your-account">
            <router-link
              class="nav-link"
              :to="$configuration.pastOrdersEnabled ? '/me/orders' : '/me'"
            >
              <font-awesome-icon icon="user" />
              {{ $t('yourAccount') }}
            </router-link>
          </li>
          <li class="nav-item" v-if="$configuration.listEnabled" data-testid="header-shopping-list">
            <router-link class="nav-link" to="/me/lists">
              <font-awesome-icon icon="list-check" />
              {{ $t('shoppingLists') }}
            </router-link>
          </li>
          <li
            class="nav-item"
            v-if="
              ($configuration.cartEnabled || isCustomerModeScan) &&
                !$configuration.orderTypesEnabled
            "
          >
            <router-link class="nav-link" to="/co">
              <font-awesome-icon icon="cart-shopping-fast" />
              {{ $t('checkout') }}
            </router-link>
          </li>
          <li
            class="nav-item"
            v-if="$configuration.includeCircularLinkInMenu"
            data-testid="header-circular"
          >
            <router-link class="nav-link" to="/circular">
              <font-awesome-icon icon="tags" /> {{ circularLinkText }}
            </router-link>
          </li>
          <li
            class="nav-item"
            v-if="$configuration.allowCouponClipping"
            data-testid="header-digital-coupons"
          >
            <router-link class="nav-link" to="/cpb"
              ><font-awesome-icon icon="scissors" /> {{ $t('digitalCoupons') }}</router-link
            >
          </li>
          <li class="nav-item" v-if="showGiftCardLinks" data-testid="header-e-gift-cards">
            <router-link class="nav-link" :to="giftCardUrl"
              ><font-awesome-icon icon="gift" /> {{ $t('giftCards') }}</router-link
            >
          </li>
          <WCLanguagesMenu />
        </ul>
      </nav>
    </div>
  </section>
</template>

<script>
import { getLocationPhone } from '@/utils';
import WCEmployeeAssociationBanner from '@/modules/employee/components/WCEmployeeAssociationBanner/WCEmployeeAssociationBanner.vue';
import GiftCardMixin from '@/modules/giftcard/mixins/GiftCardMixin';
import WCLanguagesMenu from '../WCLanguagesMenu/WCLanguagesMenu.vue';

export default {
  components: { WCEmployeeAssociationBanner, WCLanguagesMenu },
  props: {
    isEmployee: { type: Boolean },
    isCustomer: { type: Boolean },
    isCustomerModeScan: { type: Boolean },
  },
  computed: {
    locationPhone() {
      return getLocationPhone(this.$configuration.store);
    },
    circularLinkText() {
      return this.$configuration.circularLinkText
        ? this.$configuration.circularLinkText
        : this.$t('weeklyAd');
    },
  },
  mixins: [GiftCardMixin],
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/_tools.scss';
@import '~@/assets/styles/_settings.scss';

.wc-header__top {
  background-color: var(--gray-200, $gray-200);
  :deep(a) {
    color: var(--gray-700, $gray-700);

    &:hover {
      color: black;
    }
  }
  .underline-link-from-center {
    background-image: linear-gradient(var(--gray-700, $gray-700), var(--gray-700, $gray-700));
  }
}

.nav-link {
  display: block;
  padding: 0.25rem 0.875rem;
}
</style>
